<template>
    <v-container class="">
        <v-row class="py-5" justify="center" align="center">
            <searchBar label="New Discussions" :value="posts.count" @searching="searchQuery=$event">
            </searchBar>
            <v-col cols="12" class="d-flex justify-end pr-0 pt-0" style="">
                <v-btn class="ma-1 text-decoration-underline text-capitalize text-subtitle-1 btn-underline mr-0 pr-0"
                    color="primary" plain :ripple="false" :to="{path:'/discussions'}">
                    view all discussions
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="mb-3 pl-0 ml-0">
            <v-col cols="12" class="ma-0 pl-0">
                <v-card class="mb-3  ml-0 pl-0" elevation="0" v-for="(info, index) in filteredPosts" :key="index">
                    <v-row class="ml-0 pl-0" align="center">
                        <v-col class="ml-0 pl-0" cols="12" v-if="info.title || info.description">
                            <v-row class="ml-0 pl-0">
                                <v-card-title v-text="info.title"
                                    class="text-h5 pa-0 text-capitalize font-weight-medium text-justify"
                                    style="font-size:18px !important;">
                                </v-card-title>
                                <v-card-text class="text-caption pa-0 text-capitalize"
                                    style="font-size:15px !important;">
                                    <span
                                        class="text-decoration-underline text-capitalize font-italic">{{info.full_name}},</span>
                                    <span class="pl-1 font-italic">{{getDate(info.added)}}</span>
                                </v-card-text>

                                <!-- <v-card-text v-text="info.description" v-if="info.description.length<200 || showMore"
                                    class="text-subtitle-1 font-weight-regular pl-0 py-2 text-justify"></v-card-text>
                                <v-card-text v-text="info.description.slice(0, 200)" v-else
                                    class="text-subtitle-1 font-weight-regular pl-0 py-2 text-justify"></v-card-text>
                                <a @click="postSelected(info)">{{linkText}}</a> -->
                                <v-card-text class="text-subtitle-1 font-weight-regular px-0 py-2">
                                    <span>{{info.description.slice(0, 100)}}...</span>
                                    <a @click="postSelected(info)">{{linkText}}</a>
                                </v-card-text>
                            </v-row>
                            <!-- </v-card> -->
                        </v-col>
                    </v-row>
                    <v-row class="pt-4">
                        <v-col cols="6" class="">
                            <span class="text-capitalize font-italic"
                                style="font-size:15px !important;">Comments({{info.post_comment.length}})</span>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end mr-0 pr-0">
                            <router-link :to="{name: 'User', params: {id: info.user}}" tag="span" class="clickable">
                                <v-btn small class="mr-2">User Details</v-btn>
                            </router-link>
                            <v-btn color="#67ac5b" v-if="info.post_status=='new' || info.post_status=='rejected'"
                                :disabled="disabledButtons" @click="updatePostStatusProperty('approved', info.id)" small
                                class="white--text mr-2">Approve
                            </v-btn>
                            <v-btn color="#ed6237" v-if="info.post_status=='new' || info.post_status=='approved'"
                                :disabled="disabledButtons" @click="updatePostStatusProperty('rejected', info.id)" small
                                class="white--text mr-2">Reject
                            </v-btn>
                            <v-btn color="#d63928" :disabled="disabledButtons" @click="deletePost(info)" small
                                class="white--text">Delete</v-btn>
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0 mr-0 pr-0">
                            <v-divider class="mb-6"></v-divider>
                        </v-col>
                    </v-row>
                    <!-- <v-divider class="mt-1 mb-6"></v-divider> -->
                </v-card>
                <v-row justify="center" align="center" class="" v-if="posts.data.length>0">
                    <v-pagination v-model="page" :length="Math.ceil(posts.count/10)" :total-visible="7" color="primary"
                        @next="fetchAllPostsWithUrl(posts.next)" @previous="fetchAllPostsWithUrl(posts.previous)"
                        @input="fetchAllPostsWithPage($event)"></v-pagination>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog v-model="deleteDialog" width="600" persistent>
            <v-card class="rounded-lg">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-card-title>Do you want to delete this discussion?</v-card-title>
                        </v-col>
                        <v-col cols="12">
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="green--text" @click="confirmDelete">Yes</v-btn>
                                <v-btn class="red--text" @click="cancelDelete">No</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import {
        mapActions,
        mapGetters,
        mapMutations
    } from 'vuex'
    import searchBar from '@/components/searchBar';
    export default {
        title: () => ('Post Settings'),
        metaInfo: {
            title: 'Discussion Settings'
        },
        components: {
            searchBar,
        },
        data: () => ({
            showMore: false,
            linkText: 'Read full discussion',
            disabledButtons: false,
            deleteDialog: false,
            deletedPostId: new Number(),
            overlay: false,
            searchQuery: '',
            page: 1,
            postPerPage: 10,
            postItemsPerPage: [{
                    text: '5',
                    value: 5
                },
                {
                    text: '10',
                    value: 10
                },
                {
                    text: '15',
                    value: 15
                },
                {
                    text: '20',
                    value: 20
                },
                {
                    text: '100',
                    value: 100
                },
                {
                    text: 'All',
                    value: null
                },
            ]
        }),
        computed: {
            ...mapGetters('user', {
                posts: 'getPosts'
            }),
            ...mapGetters('posts', {
                comments: 'getComments'
            }),
            filteredPosts() {
                if (this.searchQuery) {
                    return this.posts.data.filter((post) => {
                        return this.searchQuery.toLowerCase().split(' ').every((search) => {
                            return post.title.toLowerCase().includes(search) || post.description
                                .toLowerCase().includes(
                                    search) || post.full_name.toLowerCase().includes(search)
                        })
                    })
                } else {
                    return this.posts.data
                }
            },
            currentPagePosts() {
                return this.postPerPage != null ? this.filteredPosts.slice((this.page - 1) * this.postPerPage, (this
                        .page - 1) *
                    this.postPerPage + this.postPerPage) : this.filteredPosts
            }
        },
        methods: {
            ...mapActions('user', [
                'fetchAllPosts',
                'updatePostStatus',
                'deleteStory',
                'fetchAllPostsWithUrl',
                'fetchAllPostsWithPage'
            ]),
            ...mapMutations('user', [
                'setPostStatusProperty',
                'setPost'
            ]),
            ...mapActions('posts', [
                'fetchComments'
            ]),
            moreLess() {
                this.showMore = !this.showMore
                if (this.showMore) {
                    this.linkText = 'less'
                } else {
                    this.linkText = 'Read full discussion'
                }
            },
            updatePostStatusProperty(status, id) {
                this.disabledButtons = true
                this.setPostStatusProperty({
                    status,
                    id
                })
                this.updatePostStatus().then(() => {
                    this.fetchAllPosts()
                    this.disabledButtons = false
                })
            },
            deletePost(post) {
                this.deletedPostId = post.id
                this.deleteDialog = true
                // this.disabledButtons = true
            },
            cancelDelete() {
                this.deletedPostId = new Number()
                this.deleteDialog = false
            },
            confirmDelete() {
                this.deleteStory(this.deletedPostId).then(() => {
                    this.fetchAllPosts()
                    this.deleteDialog = false
                    this.disabledButtons = false
                })
            },
            getDate(date) {
                return `${new Date(date).getDate()}/${new Date(date).getMonth()+1}/${new Date(date).getFullYear()}`
            },
            postSelected(post) {
                this.setPost(post)
                this.$router.push(`/discussion/${post.title.replace(/\s/g, '-')}-${post.id}/`)
            },
        },
        mounted() {
            this.overlay = true
            this.fetchAllPosts().then(() => {
                this.overlay = false
            })
        }
    }
</script>
<style scoped>
    .text-card {
        overflow-y: scroll;
        padding: 0;
    }

    .row+.row {
        margin-top: 0 !important;
    }

    .btn-underline:hover {
        text-decoration: none !important;
    }
</style>